import styled from "styled-components";

export const BannerTitle = styled.h1`
  color: var(--white);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  width: 100%;
`;
